import api from 'configs/api';
import { IRequestResponse } from 'interfaces/RequestResponse';
import { IGridDataResponse, IGridPlanningData } from 'interfaces/Grid';

const endpointUrl = 'planning';

export const postPlanningGrid = async (qs, params) => {
  const url = `${endpointUrl}/activity/grid?${qs}`;
  const { data } = await api.post<
    IRequestResponse<IGridDataResponse<IGridPlanningData[]>>
  >(url, params);

  return data;
};

export const postPlanningGridOutros = async (qs, params) => {
  const url = `/diverse-activity/grid?${qs}`;
  const { data } = await api.post<
    IRequestResponse<IGridDataResponse<IGridPlanningData[]>>
  >(url, params);

  return data;
};

export const postFinishPlanActivitiesPlanning = async params => {
  const url = `${endpointUrl}/finish/plan`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postFinishRealActivitiesPlanning = async params => {
  const url = `${endpointUrl}/finish/real`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};
